export default __webpack_public_path__ + "static/ampm-brand--mobile@1x-b1d4a62ab08a5ffb2074cd88d59be1b5.webp";